<div class="tab-panel tab-panel--attachments">
  <section class="overview-card attachments-card">
    <!-- <div class="card-header">
      <span>Attachments</span>
      @if (attachmentsCount) {
        <span class="card-counter">{{ attachmentsCount }}</span>
      }
    </div> -->
    <div>
      @if (!isDoView || !isTestStepSelected) {
      <app-org-attachments
        [childcomponentInContext]="'node'"
        [containerEle]="'edit-panel-container'"
        [selectedNode]="selectedNode"
        [selectedProject]="selectedProject"
        [selectedWorkspace]="selectedWorkspace"></app-org-attachments>
      } @else {
      <app-org-attachments
        [selectedStep]="selectedTestStep"
        [childcomponentInContext]="'test-step'"
        [selectedNode]="selectedNode"
        [containerEle]="'edit-panel-container'"
        [selectedProject]="selectedProject"
        [selectedWorkspace]="selectedWorkspace"
        (onAttachmentSaved)="stepAttachmentSaved.emit($event)"></app-org-attachments>
      }
    </div>
  </section>
</div>
